import {
  FAILED_GET_BOAT,
  FAILED_GET_BOATS,
  FAILED_PERSIST_BOAT,
  RECEIVE_GET_BOAT,
  RECEIVE_GET_BOATS,
  RECEIVE_PERSIST_BOAT,
  REQUEST_PERSIST_BOAT,
} from 'redux/actions/boat'
import {RESET_STATE} from 'redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_BOAT:
    case FAILED_PERSIST_BOAT:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        }
      }
    case RECEIVE_PERSIST_BOAT:
    case RECEIVE_GET_BOAT:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        }
      }
    case RECEIVE_GET_BOATS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        }
      }
    case REQUEST_PERSIST_BOAT:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true
        }
      }
    case RESET_STATE:
      if (action.state === 'boat') {
        return {
          ...state,
          [action.screen]: initialState[action.screen]
        }
      }
    default:
      return state
  }
}
